export const inputs = ["Fullname", "Email", "Password", "Confirm Password"];
export const signs = ["Google", "Apple", "Facebook"];